import axios, { AxiosResponse } from 'axios';
import { APIConfigData } from '../../core/config/APIConfigData';
import apiHandler, { dataApiHandler } from '../handlers/apiHandler.ts';
import { RandomPrompt } from '../interface/RandomPrompt.ts';
import GetCanvasResponse from '../response/GetCanvasResponse.ts';
import GetListCanvasResponse from '../response/GetListCanvasResponse.ts';
import { GetRandomPromptResponse } from '../response/GetRandomPromptResponse.ts';
import { canvasListEndpoints } from '../rtk-endpoints/CanvasListEndpoints.ts';
import { loraEndpoints } from '../rtk-endpoints/LoraEndpoints.ts';
import { modelEndpoints } from '../rtk-endpoints/ModelEndpoints.ts';
import { styleEndpoints } from '../rtk-endpoints/StyleEndpoints.ts';

type ApiResponse<T> = AxiosResponse<{ data: T }>;

export const getModels = async (type: string, { dispatch }) => {
	return apiHandler({
		endpoint: modelEndpoints.endpoints.getModels.initiate,
		args: { type },
		dispatch,
	});
};
export const getModelCategories = async ({ dispatch }) => {
	return apiHandler({
		endpoint: modelEndpoints.endpoints.getModelCategories.initiate,
		dispatch,
	});
};
export const getListControlNetModels = async ({ dispatch }) => {
	return apiHandler({
		endpoint: modelEndpoints.endpoints.getListControlNetModels.initiate,
		dispatch,
	});
};

export const getListVideoAnyoneModelsList = (type: string, { dispatch }) => {
	return apiHandler({
		endpoint: modelEndpoints.endpoints.getListVideoAnyoneModels.initiate,
		args: { type },
		dispatch,
	});
};

export const getStyles = async (type: string, { dispatch }) => {
	return apiHandler({
		endpoint: styleEndpoints.endpoints.getStyles.initiate,
		args: { type },
		dispatch,
	});
};
export const getStyleCategories = async ({ dispatch }) => {
	return apiHandler({
		endpoint: styleEndpoints.endpoints.getStyleCategories.initiate,
		dispatch,
	});
};

export const getLoras = async ({ dispatch }) => {
	return apiHandler({
		endpoint: loraEndpoints.endpoints.getLoras.initiate,
		dispatch,
	});
};
export const getLoraCategories = async ({ dispatch }) => {
	return apiHandler({
		endpoint: loraEndpoints.endpoints.getLoraCategories.initiate,
		dispatch,
	});
};

export const getRandomPrompt = (): Promise<
	ReturnType<GetRandomPromptResponse['formatRandomPromptData']>
> =>
	new Promise((resolve, reject) => {
		try {
			axios({
				method: 'GET',
				url: `${APIConfigData.RENDERNET_BASE_URL}/v1/prompt/random`,
				params: {},
				headers: { 'Content-Type': 'text/plain' },
			})
				.then((res: ApiResponse<RandomPrompt[]>) => {
					const prompt = new GetRandomPromptResponse(res.data.data[0]).formatRandomPromptData();
					resolve(prompt);
				})
				.catch((error) => {
					reject(error?.response?.data?.err);
				});
		} catch (error) {
			reject(new Error(error.message));
		}
	});

export const createCanvas = async (
	dispatch: any = undefined,
): Promise<ReturnType<GetCanvasResponse['formatCanvasDetailsData']>> => {
	return dataApiHandler({
		endpoint: canvasListEndpoints.endpoints.createCanvas.initiate,
		dispatch,
	});
};

export const getListCanvases = async (
	page: number = 1,
	pageSize: number = APIConfigData.CANVAS_PAGE_SIZE,
	dispatch: any = undefined,
	forceRefetch: boolean = false,
): Promise<ReturnType<GetListCanvasResponse['formatListCanvasData']>> => {
	return dataApiHandler({
		endpoint: canvasListEndpoints.endpoints.listCanvas.initiate,
		args: { page, pageSize },
		dispatch,
		forceRefetch,
	});
};

export const getCanvas = (
	canvasId: string,
	dispatch: any,
	forceRefetch: boolean = false,
): Promise<ReturnType<GetCanvasResponse['formatCanvasDetailsData']>> =>
	dataApiHandler({
		endpoint: canvasListEndpoints.endpoints.getCanvas.initiate,
		args: { canvasId },
		dispatch,
		forceRefetch,
	});

export const updateCanvas = (
	canvasId: string,
	request: { [key: string]: any },
	dispatch: any,
): Promise<ReturnType<GetCanvasResponse['formatCanvasDetailsData']>> =>
	dataApiHandler({
		endpoint: canvasListEndpoints.endpoints.updateCanvas.initiate,
		args: { canvasId, request },
		dispatch,
	});

export const deleteCanvas = (
	canvasId: string,
	dispatch: any,
): Promise<ReturnType<GetCanvasResponse['formatCanvasDetailsData']>> =>
	dataApiHandler({
		endpoint: canvasListEndpoints.endpoints.deleteCanvas.initiate,
		args: { canvasId },
		dispatch,
	});
